import React, {useEffect, Fragment, useState} from 'react';
import Sidebar from '../../components/Staff/Sidebar';
import TopBar from '../../components/Staff/TopBar';
import MetaData from '../../layouts/MetaData';
import { Formik, Form } from 'formik';
import OrganizationSelect from '../../components/Form/OrganizationSelect';
import * as Yup from 'yup';
import PatientCoreFields, { patientCoreSchema, patientCoreInitial, diagnosisRuleError, toPatientPayload } from '../../components/PatientForm/PatientCoreFields';
import TextField from '../../components/Form/TextField';
import GenderSelectbox from '../../components/Form/GenderSelectbox';
import { addPatient } from '../../actions/adminActions';
import {useDispatch, useSelector} from 'react-redux'
import { useAlert } from 'react-alert';


const DoctorAddPatient = (props) => {

    const dispatch = useDispatch();
    const alert = useAlert();

    const {message, error } = useSelector(state => state.common);

    useEffect(() => {
        if(error){
            alert.error(error); return;
        }

        if(message) {
            alert.success(message);
            props?.history.push('/doctor/patients');   
        }

    }, [dispatch, alert, error, message]);

    const validate = Yup.object().shape({
		firstname: Yup.string()
        .required('First Name is required')
        .min(2, 'Should be atleast 2 characters')
        .max(20, 'Should be less than 20 characters'),
		lastname: Yup.string() 
		  .min(2, 'Should be atleast 2 characters')
		  .max(20, 'Should be less than 20 characters')
		  .required('Last Name is Required'),
        email: Yup.string().email('Invalid email').required('Email is required'),  
		DOB:Yup.string().required('DOB is required'),
        phone1: Yup.string(),
        gender: Yup.string(),
        zipCode:Yup.string(),
        address:Yup.string(),
        city:Yup.string(),
        state:Yup.string(),
        line2: Yup.string(),
        ssn:Yup.string(),
        insurancecompany: Yup.string(),
	      ...patientCoreSchema,
    });

    const [orgId, setOrgId] = useState('');
    const submitHandler = (values) => {
        if(!orgId){ alert.error('Organization is required'); return }
        const dxError = diagnosisRuleError(values);
        if (dxError) { alert.error(dxError); return }
        dispatch(addPatient(toPatientPayload({...values, organizationId: orgId})));
    }


  return <Fragment>
       <MetaData title="My Patients"/>
                <Sidebar />    

                <section className="home-section">
                {/* TopBar */}
                <TopBar />

                <div className="shadow-lg p-3 mb-5 mr-4 ml-4 rounded" style={{backgroundColor: '#FAFAFA'}}>
                    <div className="home-content">
                        <h5 className="pt-2 mt-2">Add <span style={{color: '#F95800'}}>Patient </span></h5>
                        <hr />

                        <Formik initialValues={{
                             ...patientCoreInitial,
                             firstname: '',
                             lastname:'',
                             email: '',
                             DOB: ''
                         }}
                         validationSchema={validate}
                         onSubmit={values => {
                            submitHandler(values)
                        }}
                         >
                         { formik => (
                           <div>
                               <Form>
                               <div className="row">
                                    {/* First Name */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <TextField 
                                            label="First Name" 
                                            name="firstname" 
                                            type="text" 
                                            placeholder="First Name"
                                        />
                                    </div>

                                    {/* Last Name */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <TextField 
                                            label="Last Name" 
                                            name="lastname" 
                                            type="text" 
                                            placeholder="Last Name"
                                        />
                                    </div>

                                    {/* Email */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <TextField 
                                            label="Email" 
                                            name="email" 
                                            type="email" 
                                            placeholder="Email"
                                        />
                                    </div>

                                    {/* DOB */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <TextField 
                                            label="DOB" 
                                            name="DOB" 
                                            type="date" 
                                        />
                                    </div>

                                    {/* Gender */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <GenderSelectbox 
                                        label="Gender"
                                        name="gender"
                                    />
                                    </div>

                                        <PatientCoreFields />
                                                                            {/* Organization (Session 3b) */}
                                        <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                            <OrganizationSelect value={orgId} onChange={setOrgId} practiceOnly />
                                        </div>

                                </div>{/* row ends here */}

                                 {/* Buttons */}
                                 <br/>
                                 <div className="row mr-3" style={{ float: 'right'}}>
                                    <button className="reset-btn" type="reset">Reset</button>
                                    <button className="submit-btn ml-3" type="submit">Add Patient</button>
                                </div>

                                <br/><br/><br/>
                               </Form>
                           </div>  
                         )}
                        </Formik>   
                    </div>
                </div>

                </section>
  </Fragment>
};

export default DoctorAddPatient;
